// src/components/layout/Footer.jsx
import React from 'react';


function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {currentYear} Admin Panel. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;